/**
 * Kontakt: prefill z ?stock_notify=1&product=… / ?notify_body=…
 * UX: baner, czyszczenie URL, scroll, fokus na pustym e-mailu.
 */
(function () {
  "use strict";

  var root = document.querySelector(".contact-page");
  if (!root) return;

  var ta = document.getElementById("ContactFormMessage");
  var emailEl = document.getElementById("ContactFormEmail");
  var banner = document.getElementById("contact-prefill-banner");
  var closeBtn = banner ? banner.querySelector(".contact-prefill-banner__close") : null;
  var form = document.getElementById("ContactPageForm");

  if (!ta) return;

  var stockTpl = "";
  var cfgEl = document.getElementById("contact-stock-notify-payload");
  if (cfgEl) {
    try {
      var cfg = JSON.parse(cfgEl.textContent);
      stockTpl = cfg.stockNotifyTemplate || "";
    } catch (e) {
      /* */
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function scrollToForm() {
    if (!form) return;
    var block = prefersReducedMotion() ? "start" : "nearest";
    try {
      form.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: block });
    } catch (e) {
      form.scrollIntoView(true);
    }
  }

  function focusFirstGap() {
    if (!emailEl || String(emailEl.value || "").trim() !== "") return;
    try {
      emailEl.focus({ preventScroll: true });
    } catch (e) {
      emailEl.focus();
    }
  }

  function stripPrefillParamsFromUrl() {
    if (!window.history || !window.history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has("stock_notify") && !u.searchParams.has("product") && !u.searchParams.has("notify_body")) {
        return;
      }
      u.searchParams.delete("stock_notify");
      u.searchParams.delete("product");
      u.searchParams.delete("notify_body");
      var next = u.pathname + (u.search ? u.search : "") + u.hash;
      window.history.replaceState({}, "", next);
    } catch (e) {
      /* */
    }
  }

  function showBanner() {
    if (!banner) return;
    banner.hidden = false;
  }

  function hideBanner() {
    if (!banner) return;
    banner.hidden = true;
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      hideBanner();
    });
  }

  var existing = String(ta.value || "").trim();
  if (existing !== "") return;

  var params = new URLSearchParams(window.location.search);
  var filled = false;

  var rawBody = params.get("notify_body");
  if (rawBody) {
    ta.value = decodeURIComponent(rawBody.replace(/\+/g, " "));
    filled = true;
  } else {
    var pu = params.get("product");
    if (pu && (params.get("stock_notify") === "1" || params.get("stock_notify") === "true")) {
      var decoded = decodeURIComponent(pu.replace(/\+/g, " "));
      ta.value = String(stockTpl).split("__PRODUCT_URL__").join(decoded);
      filled = true;
    } else if (pu && !params.get("stock_notify")) {
      /* tylko product= — traktuj jak zapytanie o produkt */
      var dec2 = decodeURIComponent(pu.replace(/\+/g, " "));
      ta.value = String(stockTpl).split("__PRODUCT_URL__").join(dec2);
      filled = true;
    }
  }

  if (!filled) return;

  showBanner();
  stripPrefillParamsFromUrl();

  window.requestAnimationFrame(function () {
    scrollToForm();
    focusFirstGap();
  });
})();
